import { Injectable } from '@angular/core';
import { ScanConfigType } from '@ng-cloud/badger-core/models/scan-config-type';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiService } from './api.service';

@Injectable()
export class ScanConfigTypeService extends ApiService {

  /**
   * Fetch all ScanConfigTypes
   */
  getScanConfigTypes(organizationId: number, params?: any): Observable<ScanConfigType[]> {
    let url = `organizations/${organizationId}/scan_config_types`;
    return this.http.get<ScanConfigType[]>(this.url(url), { params: params }).pipe(
      catchError((err) => this.handleError(err))
    );
  }

  /**
   * Fetch solution config type for a specific organization
   */
  getScanConfigType(organizationId: number, solution: string, storeId: number = null): Observable<ScanConfigType> {
    const url = `organizations/${organizationId}/scan_config_types/${solution}`;
    const params = storeId !== null ? { store_id: storeId } : {};
    return this.http.get<ScanConfigType>(this.url(url), { params: params }).pipe(
      catchError((err) => this.handleError(err))
    );
  }

}
